import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const GAP = {
  [HD]: 64,
  [FULL_HD]: 96,
};

export const CONTENT_MARGIN_TOP = {
  [HD]: 266,
  [FULL_HD]: 396,
};

export const POSTER_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const colors = {
  label: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    BackButton: {
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
    },
    Content: {
      y: CONTENT_MARGIN_TOP[screenSize],
    },
  };
};
